// import { diffChars } from 'diff';
import { patienceDiff } from '~/util/PatienceDiff';

// export const diffStrings1 = (a: string, b: string) => {
//   const diff = diffChars(a, b);
//   let diffLines = '';
//   let lastAnnotation = '';
//   diff.forEach((part) => {
//     if (part.added) {
//       if (lastAnnotation !== '+') {
//         if (lastAnnotation !== '') diffLines += `<</${lastAnnotation}>>`;
//         diffLines += '<<+>>';
//       }
//       lastAnnotation = '+';
//     }
//     if (part.removed) {
//       if (lastAnnotation !== '-') {
//         if (lastAnnotation !== '') diffLines += `<</${lastAnnotation}>>`;
//         diffLines += '<<->>';
//       }
//       lastAnnotation = '-';
//     }
//     diffLines += part.value;
//   });
//   return diffLines;
// };

export const diffStrings = (a: string, b: string) => {
  const diff = patienceDiff(
    b.split(new RegExp(/"/, 'g')),
    a.split(new RegExp(/"/, 'g'))
  );
  let diffLines = '';
  let lastAnnotation = '';

  diff.lines.forEach((o: any) => {
    let closeAnnotation = '';
    let printAnnotation = '';

    if (o.bIndex < 0 && o.moved) {
      diffLines += '*-m';
    } else if (o.moved) {
      diffLines += '*+m';
    } else if (o.aIndex < 0) {
      if (lastAnnotation !== '+') {
        printAnnotation = '+';
        if (lastAnnotation !== '') {
          closeAnnotation = lastAnnotation;
        }
        lastAnnotation = '+';
      }
    } else if (o.bIndex < 0) {
      if (lastAnnotation !== '-') {
        if (lastAnnotation !== '') {
          closeAnnotation = lastAnnotation;
        }
        printAnnotation = '-';
      }
      lastAnnotation = '-';
    } else {
      if (lastAnnotation !== '') {
        closeAnnotation = lastAnnotation;
      }
      printAnnotation = '';
      lastAnnotation = '';
    }

    const nextLine = `'${closeAnnotation ? `<</${closeAnnotation}>>` : ''}${
      printAnnotation ? `<<${printAnnotation}>>` : ''
    }${o.line}`;

    diffLines += nextLine;
  });
  return diffLines;
};

export const jsonIsEqual = (a: any, b: any) => {
  const aString = a && typeof a === 'object' ? JSON.stringify(a) : `${a}`;
  const bString = b && typeof b === 'object' ? JSON.stringify(b) : `${b}`;
  return aString == bString;
}
